import React, { useState } from "react";
import Image from "next/legacy/image";
import {
  availableRatingsForClasses,
  ClassRating
} from "constants/rate-classes";
import { IRateClassRatingsProps } from "./rate-class-ratings.types";
import {
  Container,
  RatingContainer,
  ImgContainer,
  Rating
} from "./rate-class-ratings.styles";

const RateClassRatings: React.FC<IRateClassRatingsProps> = ({
  selectedValue,
  onRatingClick
}) => {
  const [hoveredRatingValue, setHoveredRatingValue] =
    useState<ClassRating | null>(null);
  return (
    <Container>
      {availableRatingsForClasses.map(({ title, imgGrayscale, value, img }) => {
        const isHoveredOn = hoveredRatingValue === value;
        const isActive = isHoveredOn || selectedValue === value;
        return (
          <RatingContainer
            key={title}
            onMouseOver={() => setHoveredRatingValue(value)}
            onMouseLeave={() => setHoveredRatingValue(null)}
            active={isActive}
            onClick={(e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
              e.stopPropagation();
              onRatingClick(value);
            }}
          >
            <ImgContainer>
              <Image
                src={imgGrayscale}
                alt={title}
                layout="fill"
                priority
                style={{
                  visibility: isActive ? "hidden" : "visible"
                }}
              />
              <Image
                src={img}
                alt={title}
                layout="fill"
                style={{
                  visibility: !isActive ? "hidden" : "visible"
                }}
              />
            </ImgContainer>
            <Rating>{title}</Rating>
          </RatingContainer>
        );
      })}
    </Container>
  );
};

export default RateClassRatings;
